import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {User} from "../../../../../auth/models";

@Component({
    selector: '[jft-supplier-table-row]',
    templateUrl: './supplier-table-row.component.html',
    styleUrls: ['./supplier-table-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupplierTableRowComponent {
    @Input()
    public supplier: User;

    @Output()
    public onEditSupplier = new EventEmitter();
    @Output()
    public onArchive = new EventEmitter();

    public editSupplier(supplier) {
        this.onEditSupplier.next(supplier);
    }

    public archive(supplier) {
        this.onArchive.next(supplier);
    }
}
